module.exports = __webpack_public_path__ + "static/media/AndroidBack.3fe00fc9.png";